// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"08c105a4","56":"4e7c1567","311":"246df329","336":"69a145a9","380":"ede5f32b","384":"5a15f56c","392":"5b6e0267","417":"5dba7309","665":"ce43f9cf","895":"6d2b672b","912":"03c6c665"}[chunkId] + ".chunk.js";
};